import { useQuery } from 'react-query'
import { useProject } from '@/hooks/useProject'
import { LayerService } from '../services/layer.service'
import { useToast } from '@/components/shared/toast/useToast'

type UseLayerViewOptions = {
  enabled?: boolean
}

export const useLayerView = (
  layer?: number | null,
  options?: UseLayerViewOptions,
) => {
  const { workspaceId, projectId } = useProject()
  const { enqueueToast } = useToast()
  const queryEnabled = options?.enabled ?? true

  const { data, isLoading, refetch, isSuccess } = useQuery(
    ['layer_view_', layer],
    () =>
      LayerService.getLayerView({
        workspaceId: Number(workspaceId),
        projectId: Number(projectId),
        layerId: Number(layer),
      }),
    {
      enabled: !!workspaceId && !!projectId && !!layer && queryEnabled,
      select: ({ data }) => {
        const layerView = data?.layer_view

        if (!layerView?.image || !layerView?.map_node) {
          return null
        }

        return {
          view: layerView,
          image: LayerService.getLayerImage({
            layerId: Number(layer),
            imageName: layerView.image.image_id,
            extension: layerView.image.extension,
          }),
          points: layerView.points ?? [],
          polygons: layerView.polygons ?? [],
          options: {
            labelSize: layerView.map_node.label_size / 100,
            fontSize: layerView.map_node.font_size,
            color: layerView.map_node.color,
            borderWidth: layerView.map_node.borderwidth,
            wrapText: layerView.map_node.wrap_text,
          },
        }
      },
      onError: () => {
        enqueueToast(
          { title: 'Ошибка!', message: 'Не удалось загрузить данные о слое' },
          { variant: 'error' }
        )
      }
    }
  )

  return { layerView: data, isLoading, isSuccess, refetch }
}
